import React from 'react';

/**
 * LogoBackground — tiled company logos behind the "Major Brands" section.
 * Uses a pre-built SVG tile (public/images/company-logos-tile.svg)
 * that contains 35 real company logos in a grid pattern.
 * No API calls, no tokens, just a local static file.
 */
const LogoBackground = () => (
  <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
    {/* Tiled logos — full opacity */}
    <div
      className="absolute inset-0"
      style={{
        backgroundImage: 'url(/images/company-logos-tile.svg)',
        backgroundRepeat: 'repeat',
        backgroundSize: '784px 364px',
      }}
    />
    {/* Black overlay — 40% opacity */}
    <div
      className="absolute inset-0"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.72)' }}
    />
  </div>
);

export default LogoBackground;
